<template>
    <div class="welcome-container" @click="navigate('/home')">
        {{ platformName }}
    </div>
    <div class="rest">
        <div class="inner-container" @click="navigate('/profile')">
            <div class="inner-text">Profile</div>
        </div>
        <div class="inner-container" @click="navigate('/chat_recom')">
            <div class="inner-text">Chat With Recommender</div>
        </div>
    </div>
</template>
<script>
import { getPlatformName } from '@/util.js';
export default {
    name: 'MenuPane',
    data() {
        return {
            platformName: getPlatformName()
        }
    },
    methods: {
        navigate(path) {
            this.$router.push(path)
        }
    }
}
</script>
<style lang="scss" scoped>
.welcome-container {
    display: flex;
    width: 100%;
    height: 20vh;
    background-color: black;
    color: white;
    align-items: center;
    justify-content: center;
    font-family: 'Papyrus', fantasy;
    font-size: 24px;
}

.rest {
    display: flex;
    flex-direction: column;

    .inner-container {
        display: flex;
        width: 80%;
        height: 10vh;
        margin: 5px auto;
        align-items: center;
        justify-content: center;
        color: #ddd;
        cursor: pointer;
        border-radius: 5px;
        transition: background-color 0.3s;
        text-align: center;
        min-height: 50px;
        padding: 10px;
        word-wrap: break-word;
        text-wrap: balance;

        .inner-text {
            display: flex;
            height: 100%;
            width: 100%;
            font-size: 16px;
            font-weight: 600;
            align-items: center;
            justify-content: center;
        }
    }

    .inner-container:hover {
        background-color: #1a1a1a;
    }
}
</style>
